<template>
  <el-row class="video-list">
    <el-col :xs="24" :sm="24" class="video-list-item text-center">
      <swiper
        class="inherit-h"
        :modules="[Navigation, Thumbs]"
        :space-between="10"
        :slides-per-view="'auto'"
        :watch-slides-progress="true"
        :prevent-clicks="true"
        :prevent-clicks-propagation="true"
        navigation
      >
        <swiper-slide
          class="inherit-h"
          v-for="(item, index) in list"
          :key="item.title"
        >
          <div style="height: 170px">
            <VideoCover
              :data="{ poster: item.poster }"
              btnSize="3.75rem"
              @on-play="onPlay(item.id, index)"
            />
          </div>
          <div
            class="title fs-xl mt-2 text-hover underline-hover opacity-hover"
            :title="item.title"
          >
            <span @click="onPlay(item.id, index)">
              {{ item.title }}
            </span>
          </div>
        </swiper-slide>
      </swiper>
    </el-col>
  </el-row>
</template>

<script setup>
import { Navigation, Pagination, Scrollbar, A11y, Thumbs } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js'
import 'swiper/swiper-bundle.min.css'

// import mp4 from '@/assets/videos/IMG_9953.mp4'
import { defineProps, ref, defineEmits } from 'vue'
import VideoCover from '@/components/video/cover.vue'

import PlayBtn from '@/components/play-btn/index.vue'

const emits = defineEmits(['on-play'])

const props = defineProps({
  list: {
    type: Array
  }
})

const showControls = ref(props.list.map((_) => false))

const onPlay = (id, index) => {
  emits('on-play', { id, index })
}
</script>

<style lang="scss" scoped>
.video-list {
  &-item {
    cursor: pointer;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      background: rgba($color: #000000, $alpha: 0.4);
    }
    .play-btn {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
    &:hover {
      img {
        // transform: scale(1.1);
        // transition: all 0.8s;
      }
    }
  }
}
</style>
